// SignupForm.jsx
import { useMemo, useState } from "react";

export default function SignupForm({ branches, onSubmit, loading, error }) {
  const [branchIdx, setBranchIdx] = useState("-1");
  const [id, setId] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const grouped = useMemo(() => {
    const map = {};
    (branches || []).forEach((b) => {
      const area = b.branch_area || "기타";
      (map[area] ||= []).push(b);
    });
    return Object.entries(map);
  }, [branches]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (branchIdx === "-1") return alert("请选择分店名称。");
    if (!id) return alert("아이디를 입력해주세요.");
    if (!password || !passwordConfirm) return alert("请输入密码。");
    if (password.length < 4) return alert("密码必须至少为4个字符。");
    if (password !== passwordConfirm) return alert("两次输入的密码不一致。");

    onSubmit({
      branch_idx: branchIdx,
      id,
      user_name: userName,
      password,
      phone_number: phone,
      email,
    });
  };

  return (
    <div className="signup">
      <form onSubmit={handleSubmit} className="signupform">
        <div id="content_title">
          <h2>注册</h2>
        </div>
  
        <p>分店名称</p>
        <select value={branchIdx} onChange={(e) => setBranchIdx(e.target.value)}>
          <option value="-1">选择分店</option>
          {grouped.map(([area, list]) => (
            <optgroup key={area} label={`-----${area}-----`}>
              {list.map((b) => (
                <option key={b.branch_idx} value={String(b.branch_idx)}>
                  {b.branch_name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
  
        <p>用户名</p>
        <input value={id} onChange={(e) => setId(e.target.value)} placeholder="用户名" />
  
        <p>密码</p>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="密码" />
  
        <p>确认密码</p>
        <input type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} placeholder="确认密码" />
  
        <p>姓名</p>
        <input value={userName} onChange={(e) => setUserName(e.target.value)} placeholder="姓名" />
  
        <p>电话号码</p>
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="010-1234-5678" />
  
        <p>电子邮件</p>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="电子邮件" />
  
        <button disabled={loading} className="signupsubmit">{loading ? "가입 중…" : "注册"}</button>
        {error && <p className="error">{error}</p>}
  
        <div className="login_link">
          <a href="/cn/login">登录</a>
        </div>
      </form>
    </div>
  );
}
